import axios from 'axios';
import Constants from '../config/Constants';

export default axios.create({
    baseURL: Constants.server.baseURL,
    headers: {'Access-Control-Allow-Origin': '*'},
    timeout: 30000,
});